export class Trigger {

    constructor ( target = '.js-trigger', options = {} ) {
        this.target = target;

        this.options = {
            activeClass: 'js-active',
            closeTrigger: 'js-trigger--close',
            closeMain: false,
            scroll: true,
            ...options
        }
    }

    init () {
        this.$triggers = Array.from( document.querySelectorAll( this.target ) );
        this.$close = Array.from( document.querySelectorAll( `.${this.options.closeTrigger}` ) );

        this.fragment = window.location.hash.substr( 1 );

        this.$triggers.forEach( $trigger => {

            const parent = $trigger.parentElement;

            let $activates;
            let $collapsibles;
            if ( !!$trigger.dataset.activates ) {
                if ( $trigger.dataset.activates === 'parent' ) {
                    $activates = $trigger.parentElement;
                } else {
                    $activates = document.querySelector( `${$trigger.dataset.activates}` )
                }
            } else {
                $activates = document.querySelector( $trigger.href.replace( /^.*#/, '#' ) )
            }

            if ( !!$trigger.dataset.collapsible ) {

                $collapsibles = $trigger.querySelectorAll( `${$trigger.dataset.collapsible}` )

                if ( !$collapsibles || $collapsibles.length === 0 ) {
                    $collapsibles = parent.querySelectorAll( `${$trigger.dataset.collapsible}` )
                }

                if ( !$collapsibles || $collapsibles.length === 0 ) {
                    $collapsibles = $activates.querySelectorAll( `${$trigger.dataset.collapsible}` )
                }

            }

            if ( $trigger.hasAttribute( 'data-listener' ) ) {
                return false;
            }
            $trigger.dataset.listener = 'true';

            if ( this.fragment && ( this.fragment == $activates.id ) ) {
                this.open( $trigger, $activates, $collapsibles )
                const yOffset = -100;
                const y = $activates.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo( { top: y, behavior: 'smooth' } );
            }

            $trigger.addEventListener( 'click', this.open.bind( this, $trigger, $activates, $collapsibles ) )

        } );
    }

    open ( $trigger, $activates, $collapsibles ) {
        let scroll = this.options.scroll;
        document.body.style.overflow = 'hidden';

        if ( event ) {
            event.stopPropagation();

            if ( event.target.nodeName == 'A' || event.target.parentNode.nodeName == 'A' ) {
                return false;
            }
        }

        if ( $trigger.hasAttribute( 'data-scroll' ) ) {
            scroll = ( $trigger.dataset.scroll === 'true' );
        }

        let main = this.options.closeMain;
        if ( $trigger.hasAttribute( 'data-close-main' ) ) {
            main = ( $trigger.getAttribute( 'data-close-main' ) === 'true' );
        }

        if ( main ) {
            const $main = document.querySelector( 'main' );
            $main.addEventListener( 'click', () => {
                const $open = Array.from( document.querySelectorAll( `.${this.options.activeClass}` ) );

                $open.forEach( $item => {
                    $item.classList.remove( this.options.activeClass );
                } )

                if ( !scroll ) {
                    document.documentElement.classList.remove( 'js-no-scroll' );
                    document.body.classList.remove( 'js-no-scroll' );
                }
            } )
        }

        if ( $trigger.hasAttribute( 'data-toggle' ) ) {
            if ( !scroll ) {
                document.body.classList.toggle( 'js-no-scroll' );
            }

            $trigger.classList.toggle( this.options.activeClass );
            $activates.classList.toggle( this.options.activeClass );

            setTimeout( () => {
                if ( $trigger.parentNode.style.height ) {
                    const height = $trigger.parentNode.scrollHeight;

                    $trigger.parentNode.style.height = `${height}px`;
                }
            }, 200 );

            if ( $collapsibles ) {
                $collapsibles.forEach( $collapsible => {
                    const height = $collapsible.scrollHeight;

                    if ( !$trigger.observer ) {
                        $collapsible.observer = new MutationObserver( this.callback.bind( $collapsible ) );
                    }

                    if ( $collapsible.style.height ) {
                        $collapsible.observer.disconnect();
                        $collapsible.style.removeProperty( 'height' );
                    } else {
                        $collapsible.observer.observe( $collapsible, {
                            attributes: false,
                            childList: true,
                            subtree: true
                        } );
                        $collapsible.style.height = `${height}px`;
                    }
                } );
            }
        } else {
            $activates.classList.add( this.options.activeClass );

            if ( $collapsible ) {
                const height = $collapsible.scrollHeight;

                requestAnimationFrame( () => {
                    $collapsible.style.height = `${height}px`;
                } );
            }

            if ( !scroll ) {
                document.documentElement.classList.add( 'js-no-scroll' );
                document.body.classList.add( 'js-no-scroll' );
            }
        }
        document.body.style.overflow = null;
    }

    destroy () {
        this.$triggers.forEach( $trigger => {
            let $activates;
            if ( !!$trigger.dataset.activates ) {
                if ( $trigger.dataset.activates === 'parent' ) {
                    $activates = $trigger.parentElement;
                } else {
                    $activates = document.querySelector( `#${$trigger.dataset.activates}` )
                }
            } else {
                $activates = document.querySelector( $trigger.href.replace( /^.*#/, '#' ) )
            }

            $trigger.removeEventListener( 'click', this.open.bind( this, $trigger, $activates ) )
        } );
    }

    callback ( mutationsList, observer ) {

        // Use traditional 'for loops' for IE 11

        for ( const mutation of mutationsList ) {

            if ( mutation.type === 'childList' ) {
                const height = this.scrollHeight;

                this.style.height = `${height}px`;
            }
        }
    };
}
